import { Progress } from '@cimplico/components';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import {
    WorksheetChecklistCategory,
    WorksheetChecklistItem,
    WorksheetChecklistItemStatusEnum,
} from '../../../types/worksheet-checklist-item';
import ChecklistItem from './ChecklistItem';
import ChecklistItems from './ChecklistItems';

type ChecklistCategoryProps = {
    category?: WorksheetChecklistCategory;
    items: WorksheetChecklistItem[];
    worksheetId: string;
    compactView?: boolean;
};

function ChecklistCategory({ category, items, worksheetId, compactView = false }: ChecklistCategoryProps): JSX.Element {
    const completeItems = items.filter((i) => i.status !== WorksheetChecklistItemStatusEnum.UNCHECKED).length;
    const percentComplete = (completeItems / items.length) * 100;

    return (
        <div className="flex items-start w-full">
            <div className="ml-2 w-full">
                <section className="flex items-center gap-2 mb-4">
                    <p className="text-gray-800 text-sm font-medium">{category?.name ?? 'Other'}</p>
                    <label className="text-sm text-gray-600">
                        {completeItems} / {items.length}
                    </label>
                    <Progress type="circle" size="small" percent={percentComplete} />
                </section>
                <ChecklistItems items={items} worksheetId={worksheetId} compactView={compactView} />
            </div>
        </div>
    );
}

export default ChecklistCategory;
